export default __webpack_public_path__ + "static/media/add-plus-circle-bold-white.a1e27804.svg";